/*
 * 项目授权接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 项目授权列表
    getAuthorizationList(data) {
        return get('/wx/contract/findProjectContract', data, 'javaHost')
    },

    // 项目详情
    getAuthorizationDetail(data) {
        // return get('/app/authorization', data)
        return get('/contract/detail', data, 'javaHost')
    },

    // 获取项目人员信息
    getMenberMessage(data) {
        // return get('/app/authorization/user', data)
        return get('/contract/employee/detail', data, 'javaHost')
    },

    // 添加人员
    addMember(data) {
        // return post('/app/authorization/user', data)
        return post('/contract/authorization/user', data, 'javaHost')
    },

    // 邀请加入
    applyMember(data) {
        // return post('/project_organization/people_join_weibao', data)
        return post('/contract/employee/add', data, 'javaHost')
    },

    // 修改人员
    updateMember(data) {
        // return put('/app/authorization/user', data)
        return post('/contract/employee/edit', data, 'javaHost')
    },

    // 删除人员
    deleteMember(data) {
        // return del('/app/authorization/user', data)
        return post('/contract/employee/delete', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/projectAuthorization.js